
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacModal extends Vue {
    @Prop({ default: '' }) private title!: string
}

